import React from 'react'
import { Grid, Column, actionCell, iconCell } from 'components/grid'
import { localized } from 'decorators'

export default localized(({ dataSource, metadata, onRowClick, localize, actionProps, persistor }) => {
  return (
    <Grid
        dataSource={dataSource}
        onRowClick={onRowClick}
        persistor={persistor}>
        <Column field='id' title={localize('common.id')} width='70px' filterable={false} />
        <Column field='name' title={localize('common.name')} cell={iconCell({ icon: metadata.icon })} />
        <Column cell={actionCell({ actionProps })} width='100px' filterable={false} sortable={false} />
    </Grid>
  )
})